import { parseTemplate } from 'url-template';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import UserProductGroupNotificationSettings from './UserProductGroupNotificationSettings';

export interface Result {
	notificationSettings: UserProductGroupNotificationSettings;
}

export default function updateUserProductGroupNotificationSettings(
	client: ApiClient,
	userId: string,
	id: string,
	frequency: string
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{id}/notification-settings');

	return client
		.fetch(url.expand({ userId, id }), {
			method: 'PUT',
			body: JSON.stringify({ frequency }),
		})
		.then((response) => response.json())
		.then((response) => ({
			notificationSettings: new UserProductGroupNotificationSettings(response.notificationSettings.frequency),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
